var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.competitorsNext.length)?_c('BaseCompetitors',{attrs:{"competitors":_vm.competitorsNext,"round":_vm.epreuve.round}}):_c('div',{class:_vm.$style.competitorsEmpty},[_c('span',[_vm._v(" Aucun ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }